export const language = {
  zh: {
    "Buyer Center": "买家中心",
    "Request for Quotation": "采购寻源",
    "Inquiry Purchasing": "询价采购",
    "Bidding Purchase": "竞价采购",
    "Commodity Sourcing": "商品寻源",
    "Supplier Invitation": "供应商邀请",
    "Supplier Verification": "供应商审批",
    "Supplier Management": "供应商管理",
    'Supplier Performance': '供应商绩效',
    "Tender Management": "招投标管理",
    "Tender Management List": "招投标管理",
    "Import and Export Documents": '进出口单据服务',
    "Import Documents": '进口单据',
    "Procurement Plan Management": "采购计划管理",
    "Plan List": "计划单管理",
    "Plan Detail": "计划单详情",
    'Order Management': "订单管理",
    "Order List": "订单列表",
    "Order Detail": "订单详情",
    'Purchase Order Management': '采购单管理',
    'Price Center': '价格中心',
    'Pork Price Report': '猪肉价格提报',
    'Poultry Price Report': '禽肉价格提报',
  },
  en: {
    "Buyer Center": "Buyer Center",
    "Request for Quotation": "Request for Quotation",
    "Inquiry Purchasing": "Inquiry Purchasing",
    "Bidding Purchase": "Bidding Purchase",
    "Commodity Sourcing": "Commodity Sourcing",
    "Supplier Invitation": "Supplier Invitation",
    "Supplier Verification": "Supplier Verification",
    "Supplier Management": "Supplier Management",
    'Supplier Performance': 'Supplier Performance',
    "Import and Export Documents": 'Import and Export Documents',
    "Import Documents": 'Import Documents',
    "Tender Management": "Tender Management",
    "Tender Management List": "Tender Management List",
    "Procurement Plan Management": "Procurement Plan Management",
    "Plan List": "Plan List",
    "Plan Detail": "Plan Detail",
    'Order Management': "Order Management",
    "Order List": "Order List",
    "Order Detail": "Order Detail",
    'Purchase Order Management': 'Purchase Order Management',
    'Price Center': 'Price Center',
    'Pork Price Report': 'Pork Price Report',
    'Poultry Price Report': 'Poultry Price Report',
  },
};